import { Star, Blocks } from "lucide-react";

export const CommunityAndLetter = () => {
  const reviews = [
    {
      name: "Marc S.",
      city: "Tu vecino constructor",
      rating: 5,
      comment: "Monté el set de Star Wars en 10 días por una fracción de su precio en tienda. Quedamos en mano y la experiencia fue de diez.",
    },
    {
      name: "Laura G.",
      city: "Coleccionista local",
      rating: 5,
      comment: "Tengo varios sets Icons en casa. Ponerles fianza con Swikly y alquilarlos me da total tranquilidad y me genera ingresos extra.",
    },
    {
      name: "David R.",
      city: "Aficionado LEGO®",
      rating: 5,
      comment: "El proceso de verificación con DNI y selfie da muchísima seguridad. Es genial tener una comunidad así en tu propia ciudad.",
    },
  ];

  return (
    <section
      data-section="community-and-letter"
      className="py-16 lg:py-24 bg-[#FAF8F5] dark:bg-background border-b border-stone-200/60 dark:border-border"
    >
      <div className="container mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mx-auto text-center mb-14">
          <p className="text-xs uppercase font-bold tracking-widest text-primary mb-2">
            Opiniones reales
          </p>
          <h2 className="text-3xl sm:text-4xl font-display font-bold text-stone-900 dark:text-foreground tracking-tight">
            Fans compartiendo en su comunidad
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          {reviews.map((rev, idx) => (
            <div
              key={idx}
              className="p-6 rounded-2xl bg-white dark:bg-card border border-stone-200/80 dark:border-border shadow-xs flex flex-col justify-between"
            >
              <div>
                <div className="flex items-center gap-1 mb-3 text-amber-500">
                  {Array.from({ length: rev.rating }).map((_, i) => (
                    <Star key={i} className="h-4 w-4 fill-current" />
                  ))}
                </div>
                <p className="text-stone-700 dark:text-stone-300 text-sm leading-relaxed italic">
                  "{rev.comment}"
                </p>
              </div>
              <div className="mt-4 pt-4 border-t border-stone-100 dark:border-border">
                <p className="text-sm font-bold text-stone-900 dark:text-foreground">{rev.name}</p>
                <p className="text-xs text-stone-500">{rev.city}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="max-w-2xl mx-auto p-8 rounded-3xl bg-white dark:bg-card border border-stone-200/80 dark:border-border shadow-md text-center">
          <div className="inline-flex justify-center mb-4 p-3 rounded-2xl bg-primary/10 text-primary">
            <Blocks className="h-8 w-8" />
          </div>
          <h3 className="text-2xl font-display font-bold text-stone-900 dark:text-foreground mb-3">
            Nuestra visión para tu ciudad
          </h3>
          <p className="text-stone-600 dark:text-muted-foreground text-sm leading-relaxed mb-6">
            Creemos que la pasión por LEGO® se disfruta más cuando se comparte. En lugar de pagar cientos de euros por sets que solo montas una vez, facilitamos un modelo circular, justo y seguro donde cada set tiene una segunda vida.
          </p>
          <p className="text-xs font-semibold text-stone-400 uppercase tracking-widest">
            El equipo de Brickshare
          </p>
        </div>
      </div>
    </section>
  );
};

export default CommunityAndLetter;
